export class GooglePlaces {
    initMap() {
        const inputElement = document.getElementById("aib-register-form-point_of_sale");

        const options = {
            fields: ["place_id"],
            strictBounds: false
        };

        const googlePlacesIdElement = document.getElementById("google_places_id");

        const autocomplete = new google.maps.places.Autocomplete(inputElement, options);
        const infoWindow = new google.maps.InfoWindow();
        const infoWindowContent = document.getElementById("infowindow-content");

        infoWindow.setContent(infoWindowContent);

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if(googlePlacesIdElement){
                googlePlacesIdElement.value = place.place_id ?? null;
            }
        });
    }

    /**
     *
     * @param placesId
     * @returns {boolean}
     */
    isOpenNow(placesId){
        let xhr = new XMLHttpRequest();
        let url = 'https://places.googleapis.com/v1/places/';
        xhr.open("GET", url + placesId, false);

        let result = false;

        xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const content = JSON.parse(this.responseText);
                result = content.currentOpeningHours.openNow;
            }
        };
        
        xhr.setRequestHeader('X-Goog-Api-Key', 'AIzaSyAe-zfurgk7jJ89EudvXUeClEJjz6X8-j4');
        xhr.setRequestHeader('X-Goog-FieldMask', 'addressComponents,location,displayName,websiteUri,primaryType,businessStatus,adrFormatAddress,currentOpeningHours');
        xhr.send();

        return result;
    }

}